import { render, staticRenderFns } from "./AssignedMembers.vue?vue&type=template&id=bf1d3644&scoped=true"
import script from "./AssignedMembers.vue?vue&type=script&lang=js"
export * from "./AssignedMembers.vue?vue&type=script&lang=js"
import style0 from "./AssignedMembers.vue?vue&type=style&index=0&id=bf1d3644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1d3644",
  null
  
)

export default component.exports